import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { eventBus } from '@atc/cai-event-bus';

import { Glyphicon, IconButton, Label, Panel, Text } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { psxVDPChatSellerClick } from 'reaxl-analytics-handlers';

import authDuck from '@/ducks/authDuck.js';
import userDuck from '@/ducks/userDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

function PsxOwnerDetailsSnapshot({ name, city, showCTAs, state, isSellerVerified }) {

    const dispatch = useDispatch();

    const { id: inventoryId } = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);

    const isHasChatPreviouslyVdpListing = useSelector((currentState) => userDuck?.selectors?.isHasChatPreviouslyVdpListing(currentState, inventoryId)) || false;

    const isLoggedIn = useSelector(authDuck.selectors.isLoggedIn);

    const handleChatWithSeller = (event) => {
        eventBus.emit('psx.listingActions.openChat', {});

        if (!isHasChatPreviouslyVdpListing && isLoggedIn) {
            sendClick(psxVDPChatSellerClick, event, { inventoryId });
            dispatch(userDuck.creators.updateHasChatPreviouslyVdpListings(inventoryId));
        }
    };

    return (
        <Panel
            data-cmp="psxOwnerDetailsSnapshot"
            className="margin-bottom-5"
        >
            <Panel.Body>
                {isSellerVerified && (
                    <Label
                        bsStyle="info-inverse"
                        className="display-inline-block margin-bottom-2"
                    >
                        <Glyphicon
                            className="margin-right-1"
                            glyph="success"
                        />
                        Verified Seller
                    </Label>
                )}
                <Text
                    size={400}
                    weight="bold"
                    componentClass="div"
                >
                    {`${name} - Private Seller`}
                </Text>
                <div className="display-flex align-items-center flex-wrap gap-2">
                    <Text
                        size={400}
                        className="margin-right-1"
                    >
                        {[city, state].filter(Boolean).join(', ')}
                    </Text>
                    {showCTAs && (
                        <>
                            |
                            <IconButton
                                label="Chat with Seller"
                                glyph="commenting-o"
                                onClick={handleChatWithSeller}
                            />
                        </>
                    )}
                </div>
            </Panel.Body>
        </Panel>
    );
}

PsxOwnerDetailsSnapshot.propTypes = {
    /**
     * The owner's name
     */
    name: PropTypes.string,
    /**
     * The owner's city
     */
    city: PropTypes.string,
    /**
     * The owner's state
     */
    state: PropTypes.string,
    /**
     * This boolean determines whether the chat CTA show up
     */
    showCTAs: PropTypes.bool,
};

export default PsxOwnerDetailsSnapshot;
